import { useViewportScroll } from 'framer-motion';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { MouseEventHandler, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { BrandSitesV2Theme } from './GlobalStyle';
import { RightUpArrow } from '../../svgs/RightUpArrow';
import { CDSColor, CDSFont, fontCss, getColor } from 'design-system-webview';

interface Props {
  textColor?: string;
  forceMobile?: boolean;
}

const PRO_URL = 'https://cleaninglab-official.notion.site/fab33235930c479598c3b88c3cb169ba';

export default function Header({ textColor = 'rgba(0, 0, 0, 0.85)', forceMobile = false }: Props) {
  const { scrollY } = useViewportScroll();
  const [isScrollOnTop, setIsScrollOnTop] = useState(true);
  const [isFolded, setIsFolded] = useState(true);
  const router = useRouter();
  const scrollableElementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsScrollOnTop(scrollY.get() === 0);
    scrollY.onChange((value) => {
      setIsScrollOnTop(value === 0 && getComputedStyle(document.body).position !== 'fixed');
    });
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (isFolded) return;
      if (window.innerWidth > Number(BrandSitesV2Theme!.brandSitesV2.breakpoints.tablet.replace('px', ''))) {
        setIsFolded(true);
      }
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [isFolded]);

  // useEffect(() => {
  //   const scrollableElement = scrollableElementRef.current;
  //   if (!scrollableElement) return;

  //   if (!isFolded) lock(scrollableElement);
  //   else unlock(scrollableElement);

  //   return () => unlock(scrollableElement);
  // }, [isFolded]);

  useEffect(() => {
    if (!isFolded) {
      document.body.style.cssText = `
      overscroll-behavior-y: none;
      -webkit-overflow-scrolling: touch;

      position: fixed;
      top: -${window.scrollY}px;

      overflow-y: scroll;
      width: 100%;`;
    } else {
      const scrollY = document.body.style.top;
      document.body.style.cssText = '';
      window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    }

    // return () => {
    //   const scrollY = document.body.style.top;
    //   document.body.style.cssText = '';
    //   window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    // };
  }, [isFolded]);

  const onClickLink: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (e.currentTarget.pathname === router.pathname) {
      setIsFolded(true);
    }
  };

  return (
    <Container $isScrollOnTop={isScrollOnTop} $isFolded={isFolded} $textColor={textColor} $forceMobile={forceMobile}>
      <OuterWrapper>
        <InnerWrapper>
          <LeftSide>
            <Link href="/" passHref>
              <Logo onClick={onClickLink}>
                <FakeText>청연</FakeText>
                <LogoIcon>{LogoSvg}</LogoIcon>
              </Logo>
            </Link>
            <Items
            // animate={hasAnimation ? { opacity: [0, 0, 1] } : {}}
            // transition={{ duration: 1, times: [0, 0.6, 1], ease: [0.65, 0, 0.35, 1] }}
            // exit={{ opacity: 1 }}
            >
              <Link href="/about" passHref>
                <LeftItem onClick={onClickLink}>청연이야기</LeftItem>
              </Link>
              <LeftDropDownItem>
                <DropDownBox>
                  <LeftItem>생활 청소</LeftItem>
                  <ApplyProBox>
                    <ApplyProBoxInner>
                      <Link href="/home_clean" passHref>
                        <RightItem onClick={onClickLink}>
                          <RightItemText>가사 청소</RightItemText>
                        </RightItem>
                      </Link>
                      <Link href="/office_clean" passHref>
                        <RightItem onClick={onClickLink}>
                          <RightItemText>사무실 청소</RightItemText>
                        </RightItem>
                      </Link>
                    </ApplyProBoxInner>
                  </ApplyProBox>
                </DropDownBox>
              </LeftDropDownItem>
              <LeftDropDownItem>
                <DropDownBox>
                  <LeftItem>전문 청소</LeftItem>
                  <ApplyProBox>
                    <ApplyProBoxInner>
                      <Link href="/moving_clean" passHref>
                        <RightItem onClick={onClickLink}>
                          <RightItemText>이사·입주 청소</RightItemText>
                        </RightItem>
                      </Link>
                      <Link href="/aircon_clean" passHref>
                        <RightItem onClick={onClickLink}>
                          <RightItemText>에어컨 청소</RightItemText>
                        </RightItem>
                      </Link>
                    </ApplyProBoxInner>
                  </ApplyProBox>
                </DropDownBox>
              </LeftDropDownItem>
              <Link href="/store" passHref>
                <LeftItem onClick={onClickLink}>플러스샵</LeftItem>
              </Link>
            </Items>
          </LeftSide>
          <RightSide>
            <Items
            // animate={hasAnimation ? { opacity: [0, 0, 1] } : {}}
            // transition={{ duration: 1, times: [0, 0.6, 1], ease: [0.65, 0, 0.35, 1] }}
            // exit={{ opacity: 1 }}
            >
              <DropDownBox>
                <RightItem style={{ marginRight: '40px' }}>제휴·복지</RightItem>
                <ApplyProBox>
                  <ApplyProBoxInner>
                    <Link href="/commerce/store-partnership-inquiry" passHref>
                      <RightItem onClick={onClickLink}>
                        <RightItemText>입점 문의</RightItemText>
                      </RightItem>
                    </Link>
                    <Link href="/b2b_introduction" passHref>
                      <RightItem onClick={onClickLink}>
                        <RightItemText>기업복지 문의</RightItemText>
                      </RightItem>
                    </Link>
                    <Link href="https://cleaninglab-official.notion.site/B2B-8a27c107a6024cddb684aeb4cde110a1" passHref>
                      <RightItem onClick={onClickLink} target={'_blank'}>
                        <RightItemText>제휴 문의</RightItemText>
                        <RightUpArrowWrapper>
                          <RightUpArrow />
                        </RightUpArrowWrapper>
                      </RightItem>
                    </Link>
                  </ApplyProBoxInner>
                </ApplyProBox>
              </DropDownBox>
              <DropDownBox>
                <RightItem>매니저·프로 모집</RightItem>
                <ApplyProBox>
                  <ApplyProBoxInner>
                    <Link href="/manager_apply" passHref>
                      <RightItem onClick={onClickLink} target="_blank">
                        <RightItemText>{'청연매니저'}</RightItemText>
                        <RightUpArrowWrapper>
                          <RightUpArrow />
                        </RightUpArrowWrapper>
                      </RightItem>
                    </Link>
                    <Link href="https://playful-lycra-822.notion.site/1-bf06ca4bfff74ed297c912f5463ddf1f" passHref>
                      <RightItem target={'_blank'} rel="noopener noreferrer">
                        <RightItemText>{'청연프로'}</RightItemText>
                        <RightUpArrowWrapper>
                          <RightUpArrow />
                        </RightUpArrowWrapper>
                      </RightItem>
                    </Link>
                  </ApplyProBoxInner>
                </ApplyProBox>
              </DropDownBox>
            </Items>
            <Hamburger onClick={() => setIsFolded((prev) => !prev)}>{isFolded ? HamburgerSvg : CloseSvg}</Hamburger>
          </RightSide>
        </InnerWrapper>
      </OuterWrapper>
      <UnFoldContainer className="menu" ref={scrollableElementRef}>
        <UnFoldWrapper>
          <AnchorGroup>
            <AnchorGroupName>회사</AnchorGroupName>
            <Link href="/about" passHref>
              <Anchor onClick={onClickLink}>청연 이야기</Anchor>
            </Link>
            <Link href="/news" passHref>
              <Anchor onClick={onClickLink}>보도자료</Anchor>
            </Link>
            <Link href={PRO_URL} passHref>
              <Anchor target="_blank" onClick={onClickLink}>
                채용공고
              </Anchor>
            </Link>
            <Link href="https://blog.cleaninglab.co.kr" passHref>
              <Anchor target="_blank" onClick={onClickLink}>
                <AnchorTextWrapper>
                  청연 블로그
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
          </AnchorGroup>
          <AnchorGroup>
            <AnchorGroupName>서비스</AnchorGroupName>
            <Link href="/home_clean" passHref>
              <Anchor onClick={onClickLink}>가사 청소</Anchor>
            </Link>
            <Link href="/office_clean" passHref>
              <Anchor onClick={onClickLink}>사무실 청소</Anchor>
            </Link>
            <Link href="/moving_clean" passHref>
              <Anchor onClick={onClickLink}>이사·입주 청소</Anchor>
            </Link>
            <Link href="/aircon_clean" passHref>
              <Anchor onClick={onClickLink}>에어컨 청소</Anchor>
            </Link>
            <Link href="/store" passHref>
              <Anchor onClick={onClickLink}>플러스샵</Anchor>
            </Link>
            <Link href="/gift" passHref>
              <Anchor onClick={onClickLink}>선물하기</Anchor>
            </Link>
          </AnchorGroup>
          <AnchorGroup>
            <AnchorGroupName>제휴안내</AnchorGroupName>
            <Link href="/commerce/store-partnership-inquiry" passHref>
              <Anchor onClick={onClickLink}>입점 문의</Anchor>
            </Link>
            <Link href="/b2b_introduction" passHref>
              <Anchor onClick={onClickLink}>기업복지 문의</Anchor>
            </Link>
            <Link href="https://cleaninglab-official.notion.site/B2B-8a27c107a6024cddb684aeb4cde110a1" passHref>
              <Anchor target="_blank" onClick={onClickLink}>
                <AnchorTextWrapper>
                  제휴 문의
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
          </AnchorGroup>
          <AnchorGroup>
            <AnchorGroupName>모집</AnchorGroupName>
            <Link href="/manager_apply" passHref>
              <Anchor onClick={onClickLink} target="_blank">
                <AnchorTextWrapper>
                  청연매니저
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
            <Link href="https://playful-lycra-822.notion.site/1-bf06ca4bfff74ed297c912f5463ddf1f" passHref>
              <Anchor onClick={onClickLink} target="_blank" rel="noopener noreferrer">
                <AnchorTextWrapper>
                  청연프로
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
          </AnchorGroup>
          <AnchorGroup>
            <AnchorGroupName>지원안내</AnchorGroupName>
            <Link href={`${process.env.NEXT_PUBLIC_VIEW_URL}/partner/intro`} passHref>
              <Anchor onClick={onClickLink} target="_blank" rel="noopener noreferrer">
                <AnchorTextWrapper>
                  청연 파트너
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
            <Link href="/user-partner" passHref>
              <Anchor onClick={onClickLink} target="_blank">
                <AnchorTextWrapper>
                  청연 추천프로그램
                  <RightUpArrowSmall />
                </AnchorTextWrapper>
              </Anchor>
            </Link>
          </AnchorGroup>
        </UnFoldWrapper>
      </UnFoldContainer>
    </Container>
  );
}

const OuterWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 0 24px;
  flex-shrink: 0;
`;

const InnerWrapper = styled.div`
  height: 64px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};
`;

const LeftSide = styled.div`
  display: flex;
  align-items: center;
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.a`
  margin-right: 52px;

  svg path {
    /* transition: 0.2s; */
  }
`;

const LogoIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FakeText = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  text-indent: -5000px;
`;

const Items = styled.div`
  display: flex;
`;

const LeftItem = styled.a`
  margin-right: 40px;

  ${CDSFont('Body/B2_SB')}
  &:hover {
    color: #00bed6;
  }
`;

const LeftDropDownItem = styled.div``;

const RightItem = styled.a`
  ${CDSFont('Body/B4_R')}
  &:hover {
    color: #00bed6;
  }
`;

const Hamburger = styled.div`
  display: none;
  cursor: pointer;
`;

const UnFoldContainer = styled.div`
  padding: 0 24px;
  overflow-y: scroll;
  background: #ffffff;
  height: 100%;
`;

const UnFoldWrapper = styled.div`
  display: none;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};
  padding-top: 32px;
  padding-bottom: 120px;
  height: fit-content;
`;

const AnchorGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 22px;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
`;

const AnchorGroupName = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.4);
  margin-bottom: 20px;
`;

const Anchor = styled.a`
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 17px;
  line-height: 140%;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 30px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

const Container = styled.header<{
  $isScrollOnTop: boolean;
  $isFolded: boolean;
  $textColor: string;
  $forceMobile: boolean;
}>`
  height: 64px;
  margin-top: -64px;
  width: 100%;
  position: sticky;
  top: 0;
  background-color: rgba(255, 255, 255, 0);
  font-weight: 400;
  color: ${({ $textColor }) => $textColor};
  backdrop-filter: blur(0px);
  z-index: ${BrandSitesV2Theme.brandSitesV2!.headerZIndex};
  display: flex;
  flex-direction: column;
  transition: 0.2s background-color, 0.2s backdrop-filter;

  ${OuterWrapper} {
    transition: 0.2s;
    box-shadow: rgb(51 51 102 / 7%) 0px 1px 0px 0px;
  }

  ${Hamburger} svg path,
  ${Logo} svg path {
    transition: 0.2s;
    fill: ${({ $textColor }) => $textColor};
  }

  ${({ $isFolded }) =>
    $isFolded &&
    css`
      &:hover {
        color: rgba(0, 0, 0, 0.85);
        background-color: rgba(255, 255, 255, 0.8);
        backdrop-filter: blur(8px);

        ${Logo} svg path {
          fill: #00bed6;
        }

        ${Hamburger} svg path {
          fill: rgba(0, 0, 0, 0.85);
        }
      }
    `}

  ${({ $isScrollOnTop, $isFolded }) =>
    !$isScrollOnTop &&
    $isFolded &&
    css`
      color: rgba(0, 0, 0, 0.85);
      background-color: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(8px);

      ${OuterWrapper} {
        box-shadow: 0px 1px 1px rgba(255, 255, 255, 0.8);
        /* box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28); */
      }

      ${Logo} svg path {
        fill: #00bed6;
      }

      ${Hamburger} svg path {
        fill: rgba(0, 0, 0, 0.85);
      }
    `};

  ${({ $isFolded, $forceMobile, theme }) =>
    !$isFolded &&
    css`
      color: rgba(0, 0, 0, 0.85);

      @media (${$forceMobile ? `min-width: 0` : `max-width: ${theme.brandSitesV2!.breakpoints.tablet}`}) {
        position: fixed;
        margin-top: 0;
        height: 100vh;
        background-color: rgba(255, 255, 255, 1);
        backdrop-filter: blur(0px);

        ${UnFoldWrapper} {
          display: block;
        }

        ${Logo} svg path {
          fill: #00bed6;
        }

        ${Hamburger} svg path {
          fill: rgba(0, 0, 0, 0.85);
        }
      }
    `}

  ${({ theme, $forceMobile }) => css`
    @media (${$forceMobile ? `min-width: 0` : `max-width: ${theme.brandSitesV2!.breakpoints.tablet}`}) {
      ${Hamburger} {
        display: inline-block;
      }

      ${Items} {
        display: none;
      }

      ${InnerWrapper} {
        max-width: ${theme.brandSitesV2!.containerWidths!.tablet};
      }

      ${UnFoldWrapper} {
        max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.tablet};
      }

      ${AnchorGroup} {
        margin-bottom: 20px;
      }
    }
  `}

  ${({ theme, $forceMobile }) => css`
    @media (${$forceMobile ? `min-width: 0` : `max-width: ${theme.brandSitesV2!.breakpoints.mobile}`}) {
      ${UnFoldWrapper} {
        padding-top: 30px;
      }
    }
  `}

  ${({ $forceMobile }) =>
    $forceMobile &&
    css`
      max-width: 430px;
    `}
`;

const DropDownBox = styled.div`
  position: relative;
  display: inline-block;

  &:hover {
    ${LeftItem} {
      color: #00bed6;
    }

    ${RightItem} {
      color: #00bed6;
    }
  }
`;

const ApplyProBox = styled.div`
  ${fontCss('Body/B3_SB')}
  display: none;

  position: absolute;
  top: 0;
  left: -18px;

  padding-top: 30px;

  ${DropDownBox}:hover & {
    display: block;
  }
`;

const ApplyProBoxInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  min-width: 127px;
  padding: 20px;

  background-color: ${getColor('Surface/Primary')};
  border-radius: 8px;

  box-shadow: 0 2px 30px 0 #0000000d;
`;

const RightItemText = styled.div`
  display: inline-block;
  color: ${CDSColor('Text/Primary')};

  ${CDSFont('Body/B3_SB')}
  &:hover {
    color: #00bed6;
  }
`;

const RightUpArrowWrapper = styled.div`
  display: inline-block;
  margin-left: 2px;

  svg {
    position: relative;
    top: -4px;

    path {
      ${RightItem}:hover & {
        fill: #00bed6;
      }
    }
  }
`;

const LogoSvg = (
  <svg width="60" height="20" viewBox="0 0 60 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.7083 4.20251C15.8566 4.20251 15.0202 4.38501 14.2497 4.74493C13.4791 5.10484 12.7999 5.62698 12.2524 6.28091L7.81678 7.73072V4.20251H4.42546V7.7358L1.0544 6.63069L0 9.85475L3.35584 10.9548L1.29266 13.7936L4.04526 15.7858L6.11859 12.9217L8.19698 15.7858L10.9496 13.7936L8.88133 10.9497L10.909 10.2907C10.9648 11.4212 11.3551 12.5161 12.0243 13.4286C12.6985 14.3411 13.6211 15.0406 14.6856 15.436C15.7502 15.8314 16.906 15.9024 18.0161 15.6489C19.1212 15.3904 20.13 14.8176 20.9107 13.9963C21.6913 13.1751 22.2185 12.141 22.4162 11.0258C22.619 9.91051 22.4872 8.75979 22.036 7.71552C21.5899 6.67125 20.8448 5.78413 19.8968 5.16061C18.9489 4.53709 17.8387 4.20251 16.7032 4.20251H16.7083ZM16.7083 12.4046C16.2317 12.4046 15.7654 12.2627 15.37 11.9991C14.9746 11.7355 14.6653 11.3603 14.4828 10.9193C14.3004 10.4783 14.2547 9.99669 14.346 9.53032C14.4372 9.06394 14.6704 8.63306 15.005 8.29849C15.3396 7.96392 15.7704 7.73073 16.2368 7.63948C16.7032 7.54823 17.1898 7.59386 17.6309 7.77635C18.0719 7.95885 18.447 8.26807 18.7106 8.66348C18.9742 9.05888 19.1161 9.52525 19.1161 10.0018C19.1161 10.6405 18.8627 11.2539 18.4115 11.705C17.9604 12.1562 17.347 12.4097 16.7083 12.4097V12.4046Z"
      fill="#262626"
    />
    <path
      d="M32.5449 5.37428C32.8339 7.50844 34.5168 8.63888 36.651 9.18636L35.5865 11.2597C33.8629 10.839 31.7693 9.39421 31.1357 7.99509C30.5223 9.41955 28.6517 11.0316 26.6392 11.6602L25.5088 9.6274C27.5213 8.99881 29.3868 7.6149 29.696 5.37428H26.0411V3.21983H36.0782V5.37428H32.55H32.5449ZM28.1144 2.19077V0.0363304H34.0251V2.19077H28.1144ZM36.0782 19.989C33.1228 19.989 30.9684 18.3364 30.9684 15.8423C30.9684 13.3482 33.1228 11.7159 36.0782 11.7159C39.0336 11.7159 41.188 13.4344 41.188 15.8423C41.188 18.2502 39.0336 19.989 36.0782 19.989ZM36.0782 13.8552C34.5371 13.8552 33.4726 14.6308 33.4726 15.8423C33.4726 17.0539 34.5371 17.8548 36.0782 17.8548C37.6192 17.8548 38.7041 17.0792 38.7041 15.8423C38.7041 14.6054 37.5736 13.8552 36.0782 13.8552ZM38.846 11.6551V7.99002H35.9109V5.89641H38.846V0.0109863H41.3502V11.6551H38.846Z"
      fill="#262626"
    />
    <path
      d="M48.6501 1.0603C50.1506 1.0603 51.4432 1.62806 52.3456 2.5456H56.9231V0.0515137H59.407V13.3685H56.9231V8.97343H52.5737C51.6714 10.043 50.2976 10.6919 48.6552 10.6919C45.6998 10.6919 43.6265 8.61859 43.6265 5.89639C43.6265 3.17419 45.6998 1.0603 48.6552 1.0603H48.6501ZM48.6501 8.5172C50.0644 8.5172 51.1543 7.38675 51.1543 5.88118C51.1543 4.37561 50.0644 3.28571 48.6501 3.28571C47.2358 3.28571 46.1256 4.37561 46.1256 5.88118C46.1256 7.38675 47.1901 8.5172 48.6501 8.5172ZM48.1787 19.0917V12.2228H50.6829V16.8916H59.6706V19.0917H48.1787ZM56.9231 6.77844V4.77101H53.5571C53.6382 5.14613 53.6788 5.52633 53.6788 5.90145C53.6788 6.21575 53.6585 6.50976 53.5977 6.77844H56.9231Z"
      fill="#262626"
    />
  </svg>
);

const HamburgerSvg = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.19995 5.00078C3.19995 4.61418 3.51335 4.30078 3.89995 4.30078H21.9C22.2866 4.30078 22.6 4.61418 22.6 5.00078C22.6 5.38738 22.2866 5.70078 21.9 5.70078H3.89995C3.51335 5.70078 3.19995 5.38738 3.19995 5.00078ZM3.19995 12.5008C3.19995 12.1142 3.51335 11.8008 3.89995 11.8008H21.9C22.2866 11.8008 22.6 12.1142 22.6 12.5008C22.6 12.8874 22.2866 13.2008 21.9 13.2008H3.89995C3.51335 13.2008 3.19995 12.8874 3.19995 12.5008ZM3.89995 19.3008C3.51335 19.3008 3.19995 19.6142 3.19995 20.0008C3.19995 20.3874 3.51335 20.7008 3.89995 20.7008H21.9C22.2866 20.7008 22.6 20.3874 22.6 20.0008C22.6 19.6142 22.2866 19.3008 21.9 19.3008H3.89995Z"
      fill="#262626"
    />
  </svg>
);

const CloseSvg = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.9652 19.003C19.2386 19.2764 19.6818 19.2764 19.9552 19.003C20.2285 18.7296 20.2285 18.2864 19.9552 18.0131L13.9095 11.9674L19.9552 5.92171C20.2285 5.64835 20.2285 5.20513 19.9552 4.93176C19.6818 4.6584 19.2386 4.6584 18.9652 4.93176L12.9195 10.9774L6.87369 4.93159C6.60032 4.65822 6.1571 4.65822 5.88374 4.93159C5.61037 5.20495 5.61037 5.64817 5.88374 5.92154L11.9296 11.9674L5.88374 18.0132C5.61037 18.2866 5.61037 18.7298 5.88374 19.0032C6.1571 19.2766 6.60032 19.2766 6.87369 19.0032L12.9195 12.9573L18.9652 19.003Z"
      fill="#262626"
    />
  </svg>
);

const AnchorTextWrapper = styled.div`
  > svg {
    margin: 0 0 6px 2px;
  }
`;

const RightUpArrowSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.741644 0C0.410273 0 0.141644 0.268629 0.141644 0.6C0.141644 0.931371 0.410273 1.2 0.741644 1.2H4.3782L0.169821 5.52825C-0.0611802 5.76583 -0.0558465 6.14569 0.181735 6.37669C0.419316 6.60769 0.799178 6.60236 1.03018 6.36478L5.13243 2.14569V5.59665C5.13243 5.92802 5.40106 6.19665 5.73243 6.19665C6.0638 6.19665 6.33243 5.92802 6.33243 5.59665V0.6V0H5.73243H0.741644Z"
      fill="#262626"
    />
  </svg>
);
